<ng-container *ngIf="!menuapp">
	<div class="tp-wrap" [ngStyle]="themeVars" #print_table>

		<div class="tp-icon-badge">
			<i class="material-icons">trending_up</i>
		</div>

		<div class="tp-header">
			<div class="tp-title-group">
				<span class="tp-title">Sales Trends</span>
				<span class="tp-subtitle">{{ getTrendWeeks() }} week · Top 100 items</span>
			</div>
			<div class="tp-actions">
				<button class="tp-icon-btn" type="button" (click)="$event.preventDefault(); exportXls()" [disabled]="sending" title="Export Excel">
					<i class="fa fa-file-excel-o"></i>
				</button>
				<button class="tp-icon-btn" type="button" (click)="$event.preventDefault(); exportPdf()" [disabled]="sending" title="Export PDF">
					<i class="fa fa-file-pdf-o"></i>
				</button>
				<button class="tp-icon-btn" type="button" (click)="getData()" [disabled]="sending" title="Refresh">
					<i class="material-icons">refresh</i>
				</button>
				<button class="tp-icon-btn"
					type="button"
					[class.tp-icon-btn--active]="showDetails"
					(click)="toggleDetails()"
					[disabled]="loading || sending || !reportResults?.length"
					[title]="showDetails ? 'Collapse details' : 'View details'">
					<i class="material-icons">{{ showDetails ? 'expand_less' : 'expand_more' }}</i>
				</button>
			</div>
		</div>

		<div class="tp-stats" *ngIf="reportResults?.length && !loading">
			<div class="tp-stat">
				<span class="tp-stat-val">{{ reportResults.length | number }}</span>
				<span class="tp-stat-lbl">Products</span>
			</div>
			<div class="tp-stat">
				<span class="tp-stat-val">{{ getTotalSales() | currency }}</span>
				<span class="tp-stat-lbl">Total Sales</span>
			</div>
			<div class="tp-stat">
				<span class="tp-stat-val">{{ getTotalQuantity() | number }}</span>
				<span class="tp-stat-lbl">Total Qty</span>
			</div>
			<div class="tp-stat">
				<span class="tp-stat-val">{{ getAveragePrice() | currency }}</span>
				<span class="tp-stat-lbl">Avg Price</span>
			</div>
		</div>

		<div class="tp-insights" *ngIf="reportResults?.length && !loading">
			<div class="tp-alert tp-alert--up">
				<i class="material-icons">north_east</i>
				<span><strong>{{ getGrowingTrendsCount() }}</strong> growing</span>
			</div>
			<div class="tp-alert tp-alert--trial">
				<i class="material-icons">warning</i>
				<span><strong>{{ getTrialSpikesCount() }}</strong> trial spikes</span>
			</div>
			<div class="tp-alert tp-alert--stable">
				<i class="material-icons">check_circle</i>
				<span><strong>{{ getStableTrendsCount() }}</strong> stable</span>
			</div>
		</div>

		<div class="tp-loading" *ngIf="loading || sending">
			<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</div>

		<div class="tp-empty" *ngIf="!loading && !sending && loadError">
			<i class="material-icons">error_outline</i>
			<span>{{ loadError }}</span>
		</div>

		<div class="tp-empty" *ngIf="!loading && !sending && !loadError && (!reportResults || !reportResults.length)">
			<i class="material-icons">inventory</i>
			<span>No trending products for this period.</span>
		</div>

		<div class="tp-view-row" *ngIf="!loading && !sending && reportResults?.length && !showDetails">
			<button class="tp-view-btn" type="button" (click)="toggleDetails()">
				<i class="material-icons">table_rows</i>
				<span>View Details</span>
			</button>
		</div>

		<div class="tp-detail" *ngIf="!loading && !sending && reportResults?.length && showDetails">
			<div class="tp-body">
			<div class="tp-table-wrap">
				<table class="tp-table">
					<thead>
						<tr>
							<th class="pointer" (click)="sortBy('stockid')">
								Item #
								<i class="fa sort-icon" [ngClass]="getSortIcon('stockid')"></i>
							</th>
							<th class="pointer text-start" (click)="sortBy('description')">
								Description
								<i class="fa sort-icon" [ngClass]="getSortIcon('description')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('salestotal')">
								Total Sales
								<i class="fa sort-icon" [ngClass]="getSortIcon('salestotal')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('qtytotal')">
								Qty
								<i class="fa sort-icon" [ngClass]="getSortIcon('qtytotal')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('frequency')">
								Freq
								<i class="fa sort-icon" [ngClass]="getSortIcon('frequency')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('avg_price')">
								Avg Price
								<i class="fa sort-icon" [ngClass]="getSortIcon('avg_price')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('slope')">
								Trend
								<i class="fa sort-icon" [ngClass]="getSortIcon('slope')"></i>
							</th>
							<th class="pointer text-end" (click)="sortBy('volatility')">
								Volatility
								<i class="fa sort-icon" [ngClass]="getSortIcon('volatility')"></i>
							</th>
							<th class="pointer text-center" (click)="sortBy('one_time_spike')">Trial?</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let r of sortedReportResults" [class.tp-row--trial]="r.one_time_spike" [class.tp-row--up]="r.slope > 1" [class.tp-row--down]="r.slope < -1">
							<td class="tp-cell-id">{{ r.stockid }}</td>
							<td class="text-start">{{ r.description }}</td>
							<td class="text-end tp-cell-total">{{ r.salestotal | currency }}</td>
							<td class="text-end">{{ r.qtytotal | number }}</td>
							<td class="text-end">
								<span class="tp-badge tp-badge--freq">{{ r.frequency }}</span>
							</td>
							<td class="text-end">{{ r.avg_price | currency }}</td>
							<td class="text-end">
								<span class="tp-badge" [ngClass]="getTrendBadgeClass(r.slope)">
									<i class="fa" [ngClass]="getTrendIcon(r.slope)"></i>
									{{ r.slope | number:'1.2-2' }}
								</span>
							</td>
							<td class="text-end">
								<span class="tp-badge" [ngClass]="getVolatilityBadgeClass(r.volatility)">
									{{ r.volatility | number:'1.2-2' }}
								</span>
							</td>
							<td class="text-center">
								<span class="tp-badge" [ngClass]="r.one_time_spike ? 'tp-badge--trial' : 'tp-badge--neutral'">
									{{ r.one_time_spike ? 'Yes' : 'No' }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			</div>
		</div>
	</div>
</ng-container>
